import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PlantFormEntries from './PlantFormEntries';

const PlantForm = (props) => {
  const initialValues = {
    id: '',
    name: '',
    description: '',
    scientificName: '',
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [isUploading, setUploading] = useState(false);

  const resetStates = () => {
    setSelectedFiles([]);
    setPreviews([]);
    setFormValues(initialValues);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const handleOpenForm = () => {
    setOpenForm((prevState) => !prevState);

    resetStates();
    props.resetEdit();
  };

  const handleFileSelect = (fileObj) => {
    setSelectedFiles((prevState) => [fileObj, ...prevState]);
  };

  const removeImage = (slide) => {
    const newImageArr = selectedFiles.filter((obj) => {
      return obj.name !== slide.name;
    });
    setSelectedFiles(newImageArr);
  };

  const submitForm = (e) => {
    e.preventDefault();

    if (
      selectedFiles.length > 0 &&
      (!formValues.name ||
        !formValues.description ||
        !formValues.scientificName)
    ) {
      toast.error('Please add missing fields', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }

    setOpenForm(false);
    if (!props.isArea) {
      const plantAndImages = { ...formValues, images: selectedFiles };
      props.handleForm(plantAndImages);
    } else {
      props.handleForm(formValues);
    }
    resetStates();
  };

  useEffect(() => {
    if (props.editArea) {
      setFormValues({
        id: props.editArea?.id,
        name: props.editArea?.name,
        description: props.editArea?.description,
      });
      setOpenForm(true);
    }
    if (!props.editArea) {
      setOpenForm(false);
    }
  }, [props.editArea]);

  useEffect(() => {
    if (props.editPlant) {
      setFormValues({
        id: props.editPlant?.id,
        name: props.editPlant?.name,
        description: props.editPlant?.description,
        scientificName: props.editPlant?.scientificName,
      });
      setOpenForm(true);
    }
    if (!props.editPlant) {
      setSelectedFiles([]);
      setPreviews([]);
      setOpenForm(false);
    }
  }, [props.editPlant]);

  useEffect(() => {
    let previewList = [];
    selectedFiles.forEach((f) => {
      const objectUrl = URL.createObjectURL(f.file);
      const preview = { url: objectUrl, name: f.name };
      previewList = [...previewList, preview];
    });
    setPreviews(previewList);
  }, [selectedFiles]);

  return (
    <div className="text-center w-full mb-16">
      {!openForm ? (
        <button
          onClick={handleOpenForm}
          disabled={props.isLoading}
          type="submit"
          className="text-white bg-accent-500 border-0 py-2 px-8 focus:outline-none hover:bg-accent-600 rounded text-lg disabled:bg-gray-700 disabled:hover:bg-gray-700 disabled:cursor-not-allowed"
        >
          Add New
        </button>
      ) : (
        <PlantFormEntries
          isLoggedin={props.isLoggedin}
          isUploading={isUploading}
          isArea={props.isArea}
          submitForm={submitForm}
          formValues={formValues}
          handleInputChange={handleInputChange}
          handleFileSelect={handleFileSelect}
          previews={previews}
          removeImage={removeImage}
          handleOpenForm={handleOpenForm}
          editArea={props.editArea}
          editPlant={props.editPlant}
          setUploading={setUploading}
        />
      )}
    </div>
  );
};

export default PlantForm;
